import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { trimToNull } from '../utils/strings';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[trimToNull]',
})
export class TrimToNullDirective {
  constructor(
    private el: ElementRef,
    @Optional() private ngControl: NgControl,
  ) {}

  @HostListener('blur') onBlur() {
    const value = this.el.nativeElement.value;
    const trimmed = trimToNull(value.trim());
    if (value !== trimmed) {
      this.el.nativeElement.value = trimmed;
      if (this.ngControl) {
        this.ngControl.control.setValue(trimmed);
      }
    }
  }
}
